import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);


const router = new Router({
  // mode : 'history',
  routes: [
    {
      path: '/',
      name: '主页',
      redirect: '/HomePage'
    },
    {
      path: '/HomePage',
      name: 'HomePage',
      component: ()=> import('@/views/page/HomePage') // 首页
    },
    {
      path: '/eap',
      name: 'eap',
      component: ()=> import('@/views/page/eap') // eap咨询师入驻
    },
    {
      path: '/bz_entrance',
      name: 'bz_entrance',
      component: ()=> import('@/views/page/bz_entrance') // eap咨询师入驻
    },
    {
      path: '/byd_entrance',
      name: 'byd_entrance',
      component: ()=> import('@/views/page/byd_entrance') // eap咨询师入驻
    },
    {
      path: '/sq_entrance',
      name: 'sq_entrance',
      component: ()=> import('@/views/page/sq_entrance') // eap咨询师入驻
    },
    {
      path: '/teenager_entrance',
      name: 'teenager_entrance',
      component: ()=> import('@/views/page/teenager_entrance') // eap咨询师入驻
    },
    {
      path: '/xjp_entrance',
      name: 'xjp_entrance',
      component: ()=> import('@/views/page/xjp_entrance') // eap咨询师入驻
    },
    {
      path: '/fsk_entrance',
      name: 'fsk_entrance',
      component: ()=> import('@/views/page/fsk_entrance') // eap咨询师入驻
    },
    {
      path: '/xt_entrance',
      name: 'xt_entrance',
      component: ()=> import('@/views/page/xt_entrance') // eap咨询师入驻
    },

    {
      path: '/sdzy_entrance',
      name: 'sdzy_entrance',
      component: ()=> import('@/views/page/sdzy_entrance') // eap咨询师入驻
    },
    {
      path: '/sdwu_entrance',
      name: 'sdwu_entrance',
      component: ()=> import('@/views/page/sdwu_entrance') // eap咨询师入驻
    },
    {
      path: '/sdu_entrance',
      name: 'sdu_entrance',
      component: ()=> import('@/views/page/sdu_entrance') // eap咨询师入驻
    },
    {
      path: '/sdxw_entrance',
      name: 'sdxw_entrance',
      component: ()=> import('@/views/page/sdxw_entrance') // eap咨询师入驻
    },
    {
      path: '/gdwy_entrance',
      name: 'gdwy_entrance',
      component: ()=> import('@/views/page/gdwy_entrance') // eap咨询师入驻
    },
    {
      path: '/sdxd_entrance',
      name: 'sdxd_entrance',
      component: ()=> import('@/views/page/sdxd_entrance') // eap咨询师入驻
    },
    {
      path: '/qlnu_entrance',
      name: 'qlnu_entrance',
      component: ()=> import('@/views/page/qlnu_entrance') // eap咨询师入驻
    },
    {
      path: '/smkx_entrance',
      name: 'smkx_entrance',
      component: ()=> import('@/views/page/smkx_entrance') // eap咨询师入驻
    },
    {
      path: '/sdjzu_entrance',
      name: 'sdjzu_entrance',
      component: ()=> import('@/views/page/sdjzu_entrance') // eap咨询师入驻
    },
    {
      path: '/sxy_entrance',
      name: 'sxy_entrance',
      component: ()=> import('@/views/page/sxy_entrance') // eap咨询师入驻
    },
    {
      path: '/qhjsj_entrance',
      name: 'qhjsj_entrance',
      component: ()=> import('@/views/page/qhjsj_entrance') // eap咨询师入驻
    },
    {
      path: '/liu_entrance',
      name: 'liu_entrance',
      component: ()=> import('@/views/page/liu_entrance') // eap咨询师入驻
    },
    {
      path: '/sdpg_entrance',
      name: 'sdpg_entrance',
      component: ()=> import('@/views/page/sdpg_entrance') // eap咨询师入驻
    },
    {
      path: '/sold_entrance',
      name: 'sold_entrance',
      component: ()=> import('@/views/page/soldier_entrance') // eap咨询师入驻
    },
    {
      path: '/qlnuart_entrance',
      name: 'qlnuart_entrance',
      component: ()=> import('@/views/page/qlnuart_entrance') // eap咨询师入驻
    },
    {
      path: '/qlhospital_entrance',
      name: 'qlhospital_entrance',
      component: ()=> import('@/views/page/qlhospital_entrance') // eap咨询师入驻
    },
    {
      path: '/ytgc_entrance',
      name: 'ytgc_entrance',
      component: ()=> import('@/views/page/ytgc_entrance') // eap咨询师入驻
    },
    {
      path: '/qhsf_entrance',
      name: 'qhsf_entrance',
      component: ()=> import('@/views/page/qhsf_entrance') // eap咨询师入驻
    },
    {
      path: '/sdlqclub_entrance',
      name: 'sdlqclub_entrance',
      component: ()=> import('@/views/page/sdlqclub_entrance') // eap咨询师入驻--山东高速篮球俱乐部 运动员心理健康公益活动
    },
    {
      path: '/cis_entrance',
      name: 'cis_entrance',
      component: ()=> import('@/views/page/cis_entrance') // eap咨询师入驻-- 新加坡加拿大国际学校
    },

    {
      path: '/sdxyclub_entrance',
      name: 'sdxyclub_entrance',
      component: ()=> import('@/views/page/sdxyclub_entrance') // eap咨询师入驻--山东大学校友企业俱乐部
    },
    {
      path: '/zsbank_entrance',
      name: 'zsbank_entrance',
      component: ()=> import('@/views/page/zsbank_entrance') // eap咨询师入驻-- 浙商银行私人银行中心 客户心理健康公益活动
    },

    {
      path: '/ruanfujia_entrance',
      name: 'ruanfujia_entrance',
      component: ()=> import('@/views/page/ruanfujia_entrance') // eap咨询师入驻--山东达创网络科技股份有限公司
    },
    {
      path: '/atdq_entrance',
      name: 'atdq_entrance',
      component: ()=> import('@/views/page/atdq_entrance') // eap咨询师入驻-- 山东奥太电气有限公司
    },

    {
      path: '/saes_entrance',
      name: 'saes_entrance',
      component: ()=> import('@/views/page/saes_entrance') // eap咨询师入驻-- 山东省环境保护科学研究设计院有限公司
    },

    {
      path: '/horion_entrance',
      name: 'horion_entrance',
      component: ()=> import('@/views/page/horion_entrance') // eap咨询师入驻-- 山东省环境保护科学研究设计院有限公司
    },
    {
      path: '/sdyu_entrance',
      name: 'sdyu_entrance',
      component: ()=> import('@/views/page/sdyu_entrance') // eap咨询师入驻
    },

    {
      path: '/qlnuedu_entrance',
      name: 'qlnuedu_entrance',
      component: ()=> import('@/views/page/qlnuedu_entrance') // eap咨询师入驻
    },
    {
      path: '/hrcs_entrance',
      name: 'hrcs_entrance',
      component: ()=> import('@/views/page/hrcs_entrance') // eap咨询师入驻-齐鲁医院放疗科怀仁茶社
    },

    {
      path: '/detailedInformation',
      name: 'detailedInformation',
      component: ()=> import('@/views/page/detailedInformation') // 咨询师详情
    },
    {
      path: '/list',
      name: 'list',
      component: ()=> import('@/views/page/list') // 咨询师列表
    },
    {
      path: '/sparticleList',
      name: 'sparticleList',
      component: ()=> import('@/views/page/sparticleList') // 沙游资讯
    },
    {
      path: '/articleList',
      name: 'articleList',
      component: ()=> import('@/views/page/articleList') // 沙游资讯
    },
    {
      path: '/bannerList',
      name: 'bannerList',
      component: ()=> import('@/views/page/bannerList') // 沙游资讯
    },
    {
      path: '/sandplayList',
      name: 'sandplayList',
      component: ()=> import('@/views/page/sandplayList') // 沙游案例
    },
    {
      path: '/consultationDetails',
      name: 'consultationDetails',
      component: ()=> import('@/views/page/consultationDetails') // 沙游资讯
    },
    {
      path: '/payment',
      name: 'payment',
      component: ()=> import('@/views/page/payment') // 支付
    },
    {
      path: '/login',
      name: 'login',
      component: ()=> import('@/views/login/login') // 登录页
    },
    {
      path: '/consuLogin',
      name: 'consuLogin',
      component: ()=> import('@/views/consultantLogin/consuLogin') // 咨询师登录页
    },
    {
      path: '/conTopassReg',
      name: 'conTopassReg',
      component: ()=> import('@/views/consultantLogin/conTopassReg') // 咨询师 忘记密码 注册
    },
    {
      path: '/forgetToRegister',
      name: 'forgetToRegister',
      component: ()=> import('@/views/login/forgetToRegister') // 忘记密码 注册
    },
    {
      path: '/settlement',
      name: 'settlement',
      component: ()=> import('@/views/settlement/index') // 入驻
    },
    {
      path: '/personalCenter',
      name: 'personalCenter',
      component: ()=> import('@/views/core/personalCenter') // 个人中心  普通用户
    },
    {
      path: '/consonalCenter',
      name: 'consonalCenter',
      component: ()=> import('@/views/consultantCore/consonalCenter') // 个人中心  咨询师
    },
    {
      path: '/agreement',
      name: 'agreement',
      component: ()=> import('@/views/agreement/index') // 协议
    },
    {
      path: '/sandplay',
      name: 'sandplay',
      component: ()=> import('@/views/sandplay/index') // 嵌入沙盘游戏
    },
    {
      path: '/sandplay_bz',
      name: 'sandplay_bz',
      component: ()=> import('@/views/sandplay/index_bz') // 嵌入沙盘游戏
    },
    {
      path: '/sandplay_byd',
      name: 'sandplay_byd',
      component: ()=> import('@/views/sandplay/index_byd') // 嵌入沙盘游戏
    },
    {
      path: '/sandplay_fsk',
      name: 'sandplay_fsk',
      component: ()=> import('@/views/sandplay/index_fsk') // 嵌入沙盘游戏
    },
    {
      path: '/reappear',
      name: 'reappear',
      component: ()=> import('@/views/sandplay/reappear') // 嵌入沙盘游戏
    },
    {
      path: '/conViewReport',
      name: 'conViewReport',
      component: ()=> import('@/views/consultantCore/conViewReport') // 沙盘游戏回放打开报告编写页面
    },
    {
      path: '/test',
      name: 'test',
      component: ()=> import('@/views/page/test')
    },
    {
      path: '/wordCloud',
      name: 'wordCloud',
      component: ()=> import('@/views/core/WordCloud')
    },
    {
      path: '/connectList',
      name: 'connectList',
      component: ()=> import('@/views/agreement/connectList') // 协议
    },
    {
      path: '/userReport',
      name: 'userReport',
      component: ()=> import('@/views/core/userReport') // 普通用户查看报告页面
    },
    {
      path: '/video',
      name: 'video',
      component: ()=> import('@/views/page/video') // 视频连接
    },
    {
      path: '/culturalCreat',
      name: 'culturalCreat',
      component: ()=> import('@/views/core/culturalCreat') // 文创创作
    },
    {
      path: '/myCultural',
      name: 'myCultural',
      component: ()=> import('@/views/core/myCultural') // 文创创作
    },
	{
	  path: '/articleDetail',
	  name: 'articleDetail',
	  component: ()=> import('@/views/page/articleDetail') // 文章详情
	},
  {
    path: '/personalCultural',
    name: 'personalCultural',
    component: ()=> import('@/views/page/personalCultural') // 个人文创
  },
    {
      path: '/unionPay',
      name: 'unionPay',
      component: ()=> import('@/views/core/unionPay') // 通联支付
    },
  ]
})

router.afterEach((to, from, next) => document.querySelector("#app").setAttribute("style", "overflow: auto !important;"));

export default router




// WEBPACK FOOTER //
// ./src/router/index.js